/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ClockWidgetContainer_user$ref: FragmentReference;
export type ClockWidgetContainer_user = {|
  +id: string,
  +$refType: ClockWidgetContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ClockWidgetContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0b6e0b03a2b28a7a066b5b2a9250c30c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Clock/__generated__/ClockWidgetContainer_user.graphql.js